'use strict';

/* global L, Modernizr, angular */

const _ = require('lodash');

const MapController = function (
      $http, $location, $rootScope, $scope, $state, $timeout, $window,
      gettextCatalog, leafletData, AnalyticsService, ConversionService,
      AppDialogsActions, ContourPreviewActions,
      DataCaptureSelectorActions, DataExportService, Flux, IdentityService,
      MapRegistry, MapActions, OverlaySelectorActions, PdfPreviewActions,
      SaturnGrowl, sbAuth, MetricsService, ShareService, OrganizationStore
) {
  const vm = this;

  const MapStore = Flux.Store.get('MapStore');
  const AnnotationStore = Flux.Store.get('AnnotationStore');
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const DataCaptureSelectorStore = Flux.Store.get('DataCaptureSelectorStore');
  const MeasurementStore = Flux.Store.get('MeasurementStore');
  const OverlayStore = Flux.Store.get('OverlayStore');
  const NavStore = Flux.Store.get('NavStore');
  const PdfStore = Flux.Store.get('PdfPreviewStore');
  const SiteSelectorStore = Flux.Store.get('SiteSelectorStore');
  const SiteStore = Flux.Store.get('SiteStore');
  const PlanStore = Flux.Store.get('PlanStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');
  const mapController = this;
  const timeouts = [];

  // ## CONSTANTS ##
  this.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  this.mapButtonContainerDisabled = true;
  this.currentDataCaptureId = 0;
  this.currentSiteId = 0;

  this.loading = true;
  this.showNewDialog = true;
  this.showEditDialog = false;
  this.showAnnotationControls = false;
  this.showActiveLayerPopup = false;
  this.activeLayer = null;
  this.s3Url = null;

  this.sharedDataCaptureId = null;

  /* not directly used by the MapController but the share.tpl.html */
  this.SHARE_SERVICE = ShareService;
  this.onCopyShareUrl = ShareService.onCopyShareUrl;
  this.onCopyShareEmbed = ShareService.onCopyShareEmbed;
  this.getShareIframeCode = ShareService.getShareIframeCode;
  this.handleShareClick = ShareService.handleShareClick;

  this.activeTool = '';
  this.geoJSONFilteredPhotos = [];
  this.expiration = null;
  this.datacaptures = [];

  this.canPlanOverlay = false;
  this.canPlanExport = false;

  this.canPlanShare = false;

  this.canShareSite = false;
  this.preventShare = false;

  this.currentLayerType = 'tileLayer';
  this.editableTypes = [];

  this.isMeasurementActive = false;
  this.isAnnotationActive = false;
  this.isOverlayActive = false;

  this.canRequestVolumeMeasurement = DataCaptureStore.canRequestMeasurements();

  this.originalOverlordUrl = IdentityService.get('overlordUrl');
  this.overlordUrl = this.originalOverlordUrl;

  this.modernizrAvailable = typeof Modernizr !== 'undefined';
  const deviceAgent = navigator.userAgent.toLowerCase();
  // TODO: refactor this to be cleaner and remove redundancy. we don't need to support Bada either.
  this.modernizrTouch = Modernizr.touch && (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i));

  vm.openBoxFolder = DataExportService.openBoxFolder;
  vm.downloadFile = DataExportService.downloadFile;
  vm.TOOLTIPS = DataExportService.TOOLTIPS;
  vm.sendOpenDropdownAnalytics = DataExportService.sendOpenDropdownAnalytics;
  vm.showResolutions = DataExportService.showResolutions;
  vm.hasFiles = DataExportService.hasFiles;
  vm.hasOrthomosaic = DataExportService.hasOrthomosaic;
  vm.ORDER = DataExportService.ORDER;
  vm.showFiles = DataExportService.showFiles;

  vm.isBetaUser = IdentityService.isBetaUser();
  vm.isDatacaptureProcessing = true;

  this.showContourPreview = () => {

    if (vm.TOOLTIPS.dxf.isProcessing) {
      return;
    }

    ContourPreviewActions.ShowContourPreview.dispatch();
  };

  this.showPdfPreview = () => {

    if (vm.TOOLTIPS.pdf.isProcessing) {
      return;
    }

    PdfPreviewActions.ShowPdfPreview.dispatch();
  };

  this.pdfProcessing = () => {

    DataExportService.toggleExportProcessing('PDF');

    MetricsService.track('pdfReady', 'pdfRequest', {
      forceNewFlow: true
    });

    SaturnGrowl.newGrowl('Your PDF is processing. We\'ll let you know as soon as it\'s ready!', {
      id:'pdf-processing',
      time: -1
    });
  };

  this.pdfProcessingFinished = () => {

    DataExportService.toggleExportProcessing('PDF');
    this.s3Url = PdfStore.get('uri');

    SaturnGrowl.removeGrowl({
      id: 'pdf-processing'
    });

    MetricsService.track('pdfReady', 'pdfReady');

    SaturnGrowl.newGrowl('Your PDF is ready to download.', {
      id: 'pdf-ready',
      time: -1,
      cta: {
        label: 'Download PDF',
        callback: this.downloadPdf.bind(this)
      }
    });
  };

  this.downloadPdf = () => {
    $window.location.href = this.s3Url.replace('http://s3-us-west-1.amazonaws.com/skycatch-pdf/', 'https://d1xes4epbabnon.cloudfront.net/');

    SaturnGrowl.removeGrowl({
      id: 'pdf-ready'
    });

    const dataExportId = PdfStore.get('dataExportId');
    const site = MapStore.get('dataCapture').site;
    const siteId = site.id;
    const siteName = site.name;

    AnalyticsService.track('[CORE] PDF', 'PDF Downloaded', {
      dataExportId,
      siteId,
      siteName
    });
  };

  // update can share site settings
  SiteStore.getSiteSettingsCanShare().then(res => {
    this.canShareSite = res.canShareSite;
  });

  this.getResourceProxyAuth = () => {
    const resourceProxyUri = IdentityService.getResourceProxyUri();

    return sbAuth.getToken()
    .then((token) => {
      // get the expiration of the current token so you can reload tiles when it expires
      // add three zeros to the end to ensure date is correct. it's being truncated somehow which gives a date in 1970
      this.expiration = parseInt(sbAuth.getExpiration(token) + '000', 10);

      return {
        resourceProxyUri,
        token
      };
    })
    .catch((err) => {
      throw new Error('Error in resource proxy: ' + err);
    });
  };

  let tileLayerPromise;
  // overwrite _loadTile function to update tile url with new web tokens when needed
  L.TileLayer.include({
    // DO NOT make this an arrow function. it breaks *this* context for Leaflet causing errors
    _loadTile: function (tile, tilePoint) {
      tile._layer = this;
      this.onerror = this._tileOnError;

      this._adjustTilePoint(tilePoint);

      $timeout.cancel(tileLayerPromise);

      // pseudo-debounce to ensure that getToken is not called every time tiles are requested
      // without this, when the token expires, an error occurs and the user is logged out
      tileLayerPromise = $timeout(() => {
        sbAuth.getToken()
        .then((token) => {
          let layer = this;
          if (layer.options.dataCaptureId) {
            vm.getResourceProxyAuth().then((config) => {
              // dynamically build the url for datacaptures. sat maps aren't run through resource proxy
              let resourceProxyUri = config.resourceProxyUri.replace(/\/$/, '');
              layer._url = [
                resourceProxyUri,
                '/',
                token,
                '/data_captures/',
                layer.options.dataCaptureId,
                '/',
                layer.options.layerId,
                '/{z}/{x}/{y}.png'
              ].join('');
            });
          }
        });
      }, 1500);

      const tileUrl = this.getTileUrl(tilePoint);

      this.fire('tileloadstart', {
        tile,
        url: tileUrl
      });

      tile.onload = this._tileOnLoad;
      tile.src = tileUrl;
    }
  });

  this.handleMapStoreChange = _.debounce(() => {
    // TODO: This seems to be happening three times in the span of a few seconds for no reason when switching sites.  Causes map to reset zoom and other weird things.
    // Maybe check to see if like old captureId === new captureId and then break?? @javier, @chubas, @ryan, @noel
    const currentSite = MapStore.get('site');
    const currentDataCapture = MapStore.get('dataCapture');

    if (currentDataCapture) {
      vm.isDatacaptureProcessing = !currentDataCapture.dataCaptureLayers.length || !_.some(currentDataCapture.dataCaptureLayers, {
        layerType: 'tileLayer'
      });

      // we need to handle this case, since it's the only one that will
      // prevent the MAP_LOADED event to be triggered
      if (vm.isDatacaptureProcessing) {
        $scope.$emit('AFTER_MAP_LOADED');
      }
    }

    if (currentDataCapture && currentSite && currentDataCapture.siteId === currentSite.id) {
      DataExportService.getFiles(currentDataCapture.processingJob.dataFiles, 'projection');
      vm.boxFolderLink = DataExportService.getBoxLink();
      vm.geoid = DataExportService.getGeoid();
    }
    else {
      DataExportService.getFiles();
      vm.boxFolderLink = DataExportService.getBoxLink();
      vm.geoid = DataExportService.getGeoid();
      DataExportService.resetExportProcessing();
    }

    vm.projections = DataExportService.projections;
    vm.showContourButton = DataExportService.shouldShowContourButton();

    let locationSiteChanged = false;

    ConversionService.getUnitsForProject(currentSite.project);
    vm.useMetric = ConversionService.isMetric();

    if (currentSite) {
      // We shouldn't compare the object directly but check for the individual attrs instead,
      // because Store.get returns a copy of the object
      if (!this.location ||
          this.location.lat !== currentSite.location.lat ||
          this.location.lng !== currentSite.location.lng) {
        locationSiteChanged = true;
      }
    }

    if (locationSiteChanged) {
      this.visible = false;
      SiteStore.getSiteSettingsCanShare(this.currentSiteId).then(res => {
        this.canShareSite = res.canShareSite;
      });
    }

    if (currentSite) {
      this.location = currentSite.location;
    }

    this.datacaptures = [];

    if (currentDataCapture) {
      // Format the dataCaptureLayer as the booster is expecting it
      this.datacaptures = [formatDataCapture(currentDataCapture)];
    }
  }, 10);

  this.handleMapStoreLoading = () => {

    MetricsService.track('datacaptureReady', 'datacaptureDataReady');
  };

  this.handleMapStoreLoad = () => {

    MetricsService.track('datacaptureReady', 'mapReady');
    this.loading = false;

    $scope.$emit('AFTER_MAP_LOADED');
  };

  this.updateOverlordUrl = () => {
    const currentPlan = PlanStore.get('current');
    const isOverlayEnabled = !currentPlan || currentPlan.isEnabled;

    if (this.canPlanOverlay && isOverlayEnabled) {
      sbAuth.getToken()
      .then((token) => {
        $http({
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + token
          },
          url: IdentityService.getAuthApiUri() + '/sso'
        })
        .then(
          (res) => {
            // NOTE: TODO: this assumes `this.originalOverlordUrl` has a trailing slash, from IdentityService formatting
            // We need to refactor the formatting functions into a shared library to use here as well.
            this.overlordUrl = `${this.originalOverlordUrl}site/${SiteStore.get('current').id}/token/${res.data.data.token}?orgId=${IdentityService.get('currentOrganization').id}`;
          },
          (res) => {
            console.error('Request error', res);
          }
        );
      });
    }
    else {
      this.overlordUrl = $location.absUrl();
    }
  };

  this.toggleOverlordUI = _.debounce(() => {

    const currentPlan = PlanStore.get('current');
    if (currentPlan && !currentPlan.isEnabled) {
      AnalyticsService.track('[CORE] Subscription', 'New overlay - Disabled Plan', {});
      AppDialogsActions.MustBePayingCustomer.dispatch();
      return;
    }

    if (!this.canPlanOverlay) {
      AnalyticsService.track('[CORE] Subscription', 'New overlay - Insufficient Plan', {});
      AppDialogsActions.NotSupportedInPlan.dispatch();
      return;
    }

    AnalyticsService.track('[CORE] Navigate', 'Overlord', {});
    $window.open(this.overlordUrl, '_blank');
  }, 30);

  this._clearForEditing = () => {

    mapController.showNewDialog = false;
    mapController.showEditDialog = false;
    mapController.showAnnotationControls = true;
    mapController.editableTypes = [];
    mapController.annotations = [];
    mapController.measurements = [];
    mapController.overlays = [];
  };

  this.newAnnotation = () => {

    // If plan doesn't support it, check until the user tries to save
    this._clearForEditing();
    MapActions.NewAnnotationStart.dispatch();
  };

  this.newMeasurement = () => {

    const vm = this;

    if (!vm.canRequestVolumeMeasurement) {
      return;
    }

    // this._clearForEditing();
    MapActions.NewMeasurementStart.dispatch();

    const site = MapStore.get('dataCapture').site;
    const siteId = site.id;
    const siteName = site.name;

    AnalyticsService.track('[CORE] Measurements', 'New measurement', {
      siteId,
      siteName
    });

    const drawMeasurementPolygonTimeout = $timeout(() => {
      vm.drawMeasurementPolygon();
    }, 200);

    timeouts.push(drawMeasurementPolygonTimeout);
  };

  this.editAnnotation = (annotationId) => {
    // this was causing a bug in IE where the annotations were clearing
    // so there was no active layer causing IE to break and no edit capabilities
    // this._clearForEditing();
    MapActions.EditAnnotationStart.dispatch(annotationId);
  };

  this.editOverlay = (overlayId) => {
    MapActions.EditOverlayStart.dispatch(overlayId);
  };

  this.editMeasurement = (measurementId) => {
    MapActions.EditMeasurementStart.dispatch(measurementId);
  };

  this.setActiveTool = (tool) => {
    this.activeTool = tool;
  };

  this.draw = (type) => {
    this.setActiveTool(type);
    const wrapper = MapRegistry.getWrapper('primary');

    // TODO: Load this into app from strings service
    const options = {
      strings: {
        draw: {
          handlers: {
            circle: {
              tooltip: {
                start: gettextCatalog.getString('Click and drag to draw circle')
              },
              radius: gettextCatalog.getString('Radius')
            },
            marker: {
              tooltip: {
                start: gettextCatalog.getString('Click map to place marker')
              }
            },
            polygon: {
              tooltip: {
                start: gettextCatalog.getString('Click to start drawing shape'),
                cont: gettextCatalog.getString('Click to continue drawing shape'),
                end: gettextCatalog.getString('Click first point to close this shape')
              }
            },
            measurement: {
              tooltip: {
                start: gettextCatalog.getString('Click to start drawing shape'),
                cont: gettextCatalog.getString('Click to continue drawing shape'),
                end: gettextCatalog.getString('Click first point to close this shape')
              }
            },
            polyline: {
              error: gettextCatalog.getString('Error: shape edges cannot cross!'),
              tooltip: {
                start: gettextCatalog.getString('Click to start drawing line'),
                cont: gettextCatalog.getString('Click to continue drawing line'),
                end: gettextCatalog.getString('Double click to end your line')
              }
            },
            rectangle: {
              tooltip: {
                start: gettextCatalog.getString('Click and drag to draw rectangle')
              }
            },
            simpleshape: {
              tooltip: {
                end: gettextCatalog.getString('Release mouse to finish drawing')
              }
            },
            text: {
              tooltip: {
                start: gettextCatalog.getString('Click map to place text')
              }
            }
          }
        },
        edit: {
          handlers: {
            edit: {
              tooltip: {
                text: gettextCatalog.getString('Drag handles, or marker to edit feature'),
                subtext: gettextCatalog.getString('Click cancel to undo changes')
              }
            },
            remove: {
              tooltip: {
                text: gettextCatalog.getString('Click on a feature to remove')
              }
            }
          }
        }
      }
    };

    const subOptions = {
      strings: options.strings.draw.handlers[type]
    };

    wrapper.draw(type, subOptions)
    .then((leafletLayer) => {
      const geoJSON = leafletLayer.toGeoJSON();

      // construct the new annotation layer
      const annotationLayer = {
        label: AnnotationStore.getAnnotationLayerName(geoJSON, type, null, null),
        data: geoJSON,
        type
      };

      AnnotationStore.addLayer(annotationLayer);

      const mapActiveLayerTimeout = $timeout(() => {
        mapController.activeLayer = annotationLayer;
      }, 20);

      timeouts.push(mapActiveLayerTimeout);
    });
  };

  // Similar to the draw function above, but specialized only for polygons for
  // measurement request
  // TODO: Some parts of the code on both methods can be refactored
  this.drawMeasurementPolygon = () => {
    this.setActiveTool('measurement');
    const wrapper = MapRegistry.getWrapper('primary');

    const options = {
      strings: {
        draw: {
          handlers: {
            polygon: {
              tooltip: {
                start: gettextCatalog.getString('Click to start drawing shape'),
                cont: gettextCatalog.getString('Click to continue drawing shape'),
                end: gettextCatalog.getString('Click first point to close this shape')
              }
            },
            simpleshape: {
              tooltip: {
                end: gettextCatalog.getString('Release mouse to finish drawing')
              }
            }
          }
        },
        edit: {
          handlers: {
            edit: {
              tooltip: {
                text: gettextCatalog.getString('Drag handles, or marker to edit feature'),
                subtext: gettextCatalog.getString('Click cancel to undo changes')
              }
            },
            remove: {
              tooltip: {
                text: gettextCatalog.getString('Click on a feature to remove')
              }
            }
          }
        }
      }
    };

    const subOptions = {
      strings: options.strings.draw.handlers.polygon
    };

    wrapper.draw('polygon', subOptions)
    .then((leafletLayer) => {
      const geoJSON = leafletLayer.toGeoJSON();

      MeasurementStore.addLayer(geoJSON);

      const activeMeasurement = MeasurementStore.get('active');

      const activeMeasurementTimeout = $timeout(() => {
        const layer = activeMeasurement.layers[0];
        mapController.activeLayer = {
          label: activeMeasurement.name,
          data: geoJSON,
          type: 'polygon',
          id: layer.id
        };
      }, 20);

      timeouts.push(activeMeasurementTimeout);
    });
  };

  this.drawOverlay = () => {
    OverlaySelectorActions.ShowOverlaySelector.dispatch();
  };

  //////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////////////////

  // Format datacapture as the booster expect it for rendering
  const formatDataCapture = (dataCapture) => {
    dataCapture.layers = angular.copy(dataCapture.dataCaptureLayers);
    dataCapture.layers = dataCapture.layers.filter((layer) => layer.layerType === 'tileLayer');

    dataCapture.layers.forEach((layer) => {
      layer.dataCaptureId = dataCapture.id;
      layer.layerId = layer.layerData;
      layer.maxNativeZoom = layer.maxZoom;
    });

    return dataCapture;
  };

  // Format annotation for display in map
  const formatMeasurements = (measurements) => {
    const result = measurements.map((measurement) => {
      measurement.layers.forEach((layer) => {
        layer.data.properties.units = ConversionService.units;

        if (measurement.status === 'error') {
          layer.data.properties.error = true;
        }
        else {
          // If it comes from a measurement that was reprocessed successfuly
          delete layer.data.properties.error;
        }
      });

      return measurement;
    });

    return result;
  };

  // Format annotation for display in map
  const formatAnnotations = (annotations) => {
    const available = OverlayStore.get('available');

    return annotations.map((annotation) => {
      return {
        id: annotation.id,
        name: annotation.name,
        layers: annotation.annotationLayers.map((layer) => {
          // Overlay will be obtained from the list of loaded overlays.
          // If for some reason it doesn't exist, pass null as the id so
          // te renderer doesn't break. Otherwise, add it to the overlay object.
          if (layer.overlayId) {
            const overlay = _.find(available, 'id', layer.overlayId);

            if (overlay) {
              layer.overlay = { id : overlay.layerId };
            }
            else {
              layer.overlay = { id: null };
            }
          }

          layer.data.properties.units = ConversionService.units;

          return layer;
        })
      };
    });
  };

  // Format annotation for display in map
  const formatOverlays = (overlays) => overlays.map((overlay) => {
    return {
      id: overlay.id,
      name: overlay.name,
      layers: [{
        id: overlay.id,
        layerId: overlay.layerId,
        _ref: 'overlay-' + overlay.id,
        opacity: overlay.opacity,
        bounds: overlay.bounds,
        maxNativeZoom: 21
      }]
    };
  });

  // Generic method to catch whenever the state for the following stores change:
  // - AnnotationStore
  // - OverlayStore
  // - MeasurementStore
  //
  // It is in charge of assigning the respective properties passed to the map
  // directive, as well as activating / deactivating edit controls, and
  // selecting the active layer
  this._handleResourcesChange = () => {
    const activeAnnotation = AnnotationStore.get('active');
    const currentAnnotations = AnnotationStore.get('current');

    const activeOverlay = OverlayStore.get('active');
    const currentOverlays = OverlayStore.get('current');

    const activeMeasurement = MeasurementStore.get('active');
    const currentMeasurements = MeasurementStore.get('current');

    // Reset variables. These will be assigned on the body of the method.
    let annotations = [];
    let overlays = [];
    let measurements = [];
    let showAnnotationControls = false;
    let showMeasurementControls = false;
    let showNewDialog = false;
    const showEditDialog = false;
    const editableTypes = [];

    // If there is any of the active resources, they can be displayed just one
    // at a time so keep everything else disabled
    if (activeAnnotation) {
      showAnnotationControls = true;
      annotations = formatAnnotations([activeAnnotation]);
      editableTypes.push('annotations');
      mapController.isAnnotationActive = true;
    }
    else if (activeOverlay) {
      overlays = formatOverlays([activeOverlay]);
      mapController.isOverlayActive = true;
    }
    else if (activeMeasurement) {
      measurements = formatMeasurements([activeMeasurement]);

      if (MeasurementStore.isNewRecord(activeMeasurement)) {
        showMeasurementControls = true;
      }

      editableTypes.push('measurements');
      mapController.isMeasurementActive = true;
    }
    // No active resource, show all of them which are current
    else {
      annotations = formatAnnotations(currentAnnotations);
      overlays = formatOverlays(currentOverlays);
      measurements = formatMeasurements(currentMeasurements);

      showNewDialog = true;

      mapController.isAnnotationActive = false;
      mapController.isMeasurementActive = false;
      mapController.isOverlayActive = false;
    }

    this.annotations = annotations;
    this.overlays = overlays;
    this.measurements = measurements;
    this.showAnnotationControls = showAnnotationControls;
    this.showMeasurementControls = showMeasurementControls;
    this.showNewDialog = showNewDialog;
    this.showEditDialog = showEditDialog;
    this.editableTypes = editableTypes;

    this.cancelDraws();
  };

  this.handleAnnotationsChange = () => {
    this._handleResourcesChange();
  };

  this.handleMeasurementsChange = () => {
    this._handleResourcesChange();
  };

  this.handleOverlaysChange = () => {
    this._handleResourcesChange();
  };

  // Disable top map toolbar when a new site is selected on the site selector
  this._handleNewSiteSelected = () => {
    this.mapButtonContainerDisabled = true;
  };

  this.handleDataCaptureStoreChange = () => {
    // hackyty hack hack
    if (!DataCaptureStore.get('current')) {
      return;
    }

    mapController.canRequestVolumeMeasurement = DataCaptureStore.canRequestMeasurements();
    // re-enable toolbar if datacapture has been updated
    if (this.currentDataCaptureId === DataCaptureStore.get('current').id && this.currentSiteId === SiteStore.get('current').id) {
      this.mapButtonContainerDisabled = false;

      return;
    }

    this.currentDataCaptureId = DataCaptureStore.get('current').id;
    this.currentSiteId = SiteStore.get('current').id;

    this.loading = true;
  };

  /**
   * Deactivate loading animation when datacapture is loaded
   */
  this._handleDataCaptureLoaded = () => {

    this.loading = false;
  }

  this.cancelDraws = () => {
    const activeAnnotation = AnnotationStore.get('active');
    const activeMeasurement = MeasurementStore.get('active');
    if (!activeAnnotation && !activeMeasurement) {
      // Cancel any drawing being done atm
      const wrapper = MapRegistry.getWrapper('primary');

      if (wrapper) {
        wrapper.cancelDraw();
      }
    }
    this.activeTool = '';
  };

  this.handleNavStoreChange = () => {

    const isDrawerOpen = NavStore.get('drawerOpen');

    if (!isDrawerOpen) {
      mapController.showNewDialog = true;
      mapController.showAnnotationControls = false;
      mapController.showMeasurementControls = false;
      mapController.editableTypes = [];

      if (mapController.useMapboxGL) {
        $rootScope.$broadcast('resizeMap');
      }
    }
  };

  // This is triggered from a manual edit, is not a watch to the `activeLayer`
  // property specified by the Map booster directive. Hence the need to check
  // if the ids are the same, and cancel the event.
  this.handleActiveLayerChange = (layerId) => {
    // TODO: Need to do the lookup manually because the annotation layers object
    // is different (formatted), but there's no reference to the leaflet layer,
    // so do a transverse search for it
    let activeLayer;

    if (this.annotations.length) {
      // We are editing an annotation
      this.annotations.forEach((annotation) => {
        if (!activeLayer) {
          activeLayer = _.find(annotation.layers, 'id', layerId);
        }
      });
    }
    else if (this.measurements.length) {
      // We are editing a measurement
      this.measurements.forEach((measurement) => {
        // NOTE: This is the same code as annotations, but keep it unrefactored
        // since measurement layers are virtual (we only support single layer)
        // thus subject to change.
        if (!activeLayer) {
          activeLayer = _.find(measurement.layers, 'id', layerId);
        }
      });
    }

    if (activeLayer) {
      this.activeLayer = activeLayer;
    }

    const activeAnnotation = AnnotationStore.get('active');
    const activeMeasurement = MeasurementStore.get('active');
    const activeOverlay = OverlayStore.get('active');

    this.isAnnotationActive = !!activeAnnotation;
    this.isMeasurementActive = !!activeMeasurement;
    this.isOverlayActive = !!activeOverlay;
    this.showActiveLayerPopup = this.isAnnotationActive || this.isMeasurementActive || this.isOverlayActive;
    this.activeTool = '';
  };

  this.handleDeleteLayer = () => {
    this.activeLayer = null;
  };

  this.handleSiteSelected = () => {
    this.loading = true;
  };

  this.handleSiteStoreViewing = () => {
    const currentPlan = PlanStore.get('current');

    vm.isBetaUser = IdentityService.isBetaUser();

    this.canPlanOverlay = PlanStore.checkFeature('project', 'overlays');
    this.canPlanExport = PlanStore.checkFeature('project', 'file_export');
    this.canPlanShare = PlanStore.checkFeature('project', 'sharing');
    this.preventShare = !this.canPlanShare;
    if (currentPlan) {
      if (currentPlan.status !== 'success' && currentPlan.status !== null) {
        switch(currentPlan.status) {
        case 'in_progress': // subscription expired but still allow use
          SaturnGrowl.newGrowl('You have an outstanding invoice that requires attention; please check the settings page and update your payment settings!', {
            type: 'warning', time: -1, id: 'expired',
            cta: {
              callback: () => {
                $state.go('settings.organization.billing');
              }
            }
          });
          break;
        default:
            // Need to set subscription state to a valid state
        }
      }
    }
  };

  /*
  * Handles the top controls current view type
  */
  this._handleTopControlsStoreChange = () => {
    this.currentLayerType = TopControlsStore.get('currentLayerType');

    this.useMapboxGL = TopControlsStore.get('useMapboxGL');

    if (this.useMapboxGL && !IdentityService.get('viewedMapboxglDialog')) {
      const showMapboxglDialogTimeout = $timeout(() => {
        AppDialogsActions.PromptMapboxglWelcome.dispatch();
      }, 2000);

      timeouts.push(showMapboxglDialogTimeout);
    }
  };

  /**
   * EVENT LISTENERS
   */
  AnnotationStore.on(AnnotationStore.Events.Changed, this.handleAnnotationsChange.bind(this), $scope);
  AnnotationStore.on(AnnotationStore.Events.LayerAdded, this.handleActiveLayerChange.bind(this), $scope);
  DataCaptureStore.on(DataCaptureStore.Events.Changed, this.handleDataCaptureStoreChange.bind(this), $scope);
  DataCaptureSelectorStore.on(DataCaptureSelectorStore.Events.Loaded, this._handleDataCaptureLoaded, $scope);
  MapStore.on(MapStore.Events.Changed, this.handleMapStoreChange.bind(this), $scope);
  MapStore.on(MapStore.Events.ActiveLayerChanged, this.handleActiveLayerChange.bind(this), $scope);
  MapStore.on(MapStore.Events.DeleteActiveLayer, this.handleDeleteLayer.bind(this), $scope);
  MeasurementStore.on(MeasurementStore.Events.Changed, this.handleMeasurementsChange.bind(this), $scope);
  MeasurementStore.on(MeasurementStore.Events.LayerAdded, this.handleMeasurementsChange.bind(this), $scope);
  NavStore.on(NavStore.Events.Changed, this.handleNavStoreChange.bind(this), $scope);
  OverlayStore.on(OverlayStore.Events.Changed, this.handleOverlaysChange.bind(this), $scope);
  PdfStore.on(PdfStore.Events.Processing, this.pdfProcessing.bind(this), $scope);
  PdfStore.on(PdfStore.Events.Finished, this.pdfProcessingFinished.bind(this), $scope);
  PlanStore.on(PlanStore.Events.Changed, this.handleSiteStoreViewing.bind(this), $scope);
  SiteSelectorStore.on(SiteSelectorStore.Events.SiteSelected, this.handleSiteSelected.bind(this), $scope);
  TopControlsStore.on(TopControlsStore.Events.Changed, this._handleTopControlsStoreChange.bind(this), $scope);

  const deregisterNewSiteSelectedListener = $rootScope.$on('new_site_selected', this._handleNewSiteSelected.bind(this));
  const deregisterMapLoadingListener = $rootScope.$on('MAP_LOADING', _.debounce(this.handleMapStoreLoading.bind(this), 1000));
  const deregisterMapLoadedListener = $rootScope.$on('MAP_LOADED', _.debounce(this.handleMapStoreLoad.bind(this), 1000));
  // import the map opacity settings from the map booster
  const deregisterOpacityUpdatedListener = $rootScope.$on('opacityUpdated', (event, data) => {
    MapStore.$set('dcOpacity', data.dcOpacity);
    MapStore.$set('mapOpacity', data.mapOpacity);
  });

  const deregisterAnnotationEditorCloseListener = $scope.$on('annotationLayer:editor:close', () => {
    mapController.showActiveLayerPopup = false;
  });
  const deregisterMeasurementEditorCloseListener = $scope.$on('measurementLayer:editor:close', () => {
    mapController.showActiveLayerPopup = false;
  });

  // watch the user token's expiration. a new expiration time will occur each time the token is refreshed
  // this will allow us to determine when a user's token has expired and refresh the map to ensure the tiles load properly
  const deregisterTokenExpirationWatch = $scope.$watch('vm.expiration', (newValue) => {
    if (newValue) {
      // calculate when the token will expire
      const msUntilExpiration = newValue - Date.now();
      setTimeout(() => {
        // refresh map when a new token is received
        // this will update the tile's url with a new user token to ensure that tiles continue to load as user's session is refreshed
        leafletData.getMap()
        .then((map) => {
          map._resetView(map.getCenter(), map.getZoom(), true);
        });
      }, msUntilExpiration);
    }
  });

  const deregisterActiveLayerWatch = $scope.$watch(() => mapController.activeLayer, (newLayer, previousLayer) => {
    // This is used to sync the activeLayer with the MapStore.
    // Special care has to be taken, since the layer set by the map controller
    // directly IS NOT the same object as the one passed by us (it gets
    // transformed by the Annotation transform)
    if (newLayer && (!previousLayer || newLayer.id !== previousLayer.id)) {
      MapActions.SetActiveLayer.dispatch(newLayer.id);
    }
  });

  // init
  this.handleSiteStoreViewing();
  // cleanup
  $scope.$on('$destroy', () => {
    deregisterNewSiteSelectedListener();
    deregisterMapLoadingListener();
    deregisterMapLoadedListener();
    deregisterOpacityUpdatedListener();
    deregisterAnnotationEditorCloseListener();
    deregisterMeasurementEditorCloseListener();
    deregisterTokenExpirationWatch();
    deregisterActiveLayerWatch();

    timeouts.forEach((timeout) => {
      $timeout.cancel(timeout);
    });
  });
};

MapController.$inject = [
  '$http', '$location', '$rootScope', '$scope', '$state', '$timeout', '$window',
  'gettextCatalog', 'leafletData', 'AnalyticsService', 'ConversionService',
  'AppDialogsActions', 'ContourPreviewActions',
  'DataCaptureSelectorActions', 'DataExportService', 'sbFlux', 'IdentityService',
  'sbMapRegistry', 'MapActions', 'OverlaySelectorActions', 'PdfPreviewActions',
  'SaturnGrowl', 'sbAuth', 'MetricsService', 'ShareService', 'OrganizationStore'
];

module.exports = MapController;



// WEBPACK FOOTER //
// ./src/app/dash/map/MapController.js